// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordDetail_container_2X4Ii"};